var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHeaderSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6951 14.6951H15.6411L15.2681 14.3351C16.7305 12.6315 17.4759 10.4275 17.3479 8.186C17.2199 5.94446 16.2283 3.8397 14.5815 2.31363C12.9347 0.787558 10.7607 -0.041124 8.51592 0.00157156C6.27114 0.0442671 4.1302 0.955019 2.54261 2.54261C0.955019 4.1302 0.0442671 6.27114 0.00157156 8.51592C-0.041124 10.7607 0.787557 12.9347 2.31363 14.5815C3.8397 16.2283 5.94446 17.2199 8.186 17.3479C10.4275 17.4759 12.6315 16.7305 14.3351 15.2681L14.6951 15.6411V16.6941L21.3621 23.3481L23.3491 21.3611L16.6951 14.6951ZM8.69514 14.6951C7.50846 14.6951 6.34842 14.3433 5.36172 13.684C4.37503 13.0247 3.60599 12.0876 3.15187 10.9912C2.69774 9.89489 2.57892 8.68849 2.81043 7.5246C3.04194 6.36072 3.61339 5.29162 4.4525 4.4525C5.29162 3.61339 6.36072 3.04194 7.5246 2.81043C8.68849 2.57892 9.89489 2.69774 10.9912 3.15187C12.0876 3.60599 13.0247 4.37503 13.684 5.36172C14.3433 6.34842 14.6951 7.50846 14.6951 8.69514C14.6961 9.48342 14.5415 10.2641 14.2402 10.9926C13.9389 11.721 13.4969 12.3828 12.9395 12.9402C12.382 13.4975 11.7201 13.9394 10.9916 14.2406C10.2632 14.5417 9.48242 14.6962 8.69414 14.6951H8.69514Z",
    fill: "#FDFDFD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHeaderSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_header_search.11cc3f32b3b5b39daaeb81a5776c0a92.svg";